import { Fragment, useEffect } from 'react';

import { gaTrackSignupError } from 'utils/google-analytics/gaTracking';

import Button from 'components/buttons/button';

const HandleDuplicateLocation = ({ handleClose, uniqueId, formValues, claimedNumber, duplicateWorkplace }) => {

  useEffect(() => {
    window.posthog?.capture('View location claimed dialog');
    gaTrackSignupError('location already claimed');
  }, []);

  const cancelClicked = () => {
    window.posthog?.capture('Click location claimed dialog', {
      'Action taken on location claimed dialog': 'Cancel',
    });
    handleClose();
  };

  const createWorkplaceClicked = () => {
    window.posthog?.capture('Click location claimed dialog', {
      'Action taken on location claimed dialog': 'Create Workplace',
    });
    duplicateWorkplace();
  };

  return (
    <Fragment>
      <div className="error-message">
        <h5 className="title">Business Listing Used by other Workplaces</h5>
        <hr />
        <p>
          {formValues.company} is currently used by {claimedNumber} other workplaces. Would you like to continue using this address?
        </p>
        <hr />
      </div>
      <div className="error-button-group">
        <Button
          className="button button-cancel"
          type="button"
          text="Cancel"
          onClick={ cancelClicked }
        />
        <Button
          className="button button-login"
          type="button"
          text="Create Workplace"
          onClick={ createWorkplaceClicked }
        />
      </div>
    </Fragment>);
};

export default HandleDuplicateLocation;
